export const modifierList = [
  // Icon categories
  'arrow-navigation',
  'navigation',
  // Icon sizes
  'xxsmall',
  'xsmall',
  'small',
  'medium',
  'xlarge',
  // Icon colors
  'c-light',
  'c-medium',
  'c-medium-light',
  'c-medium-light-2',
  'c-dark',
  'c-primary',
  'c-primary-arrow',
  'c-secondary-arrow',
  'c-neutral',
  'c-success',
  'media',
  'mix',
  'neutral',
  // Icon names
  'alert',
  'arrow',
  'arrow-down',
  'arrow-link',
  'arrow-player-dx',
  'arrow-player-sx',
  'arrow-player-bold-dx',
  'arrow-player-bold-sx',
  'avatar-placeholder-empty',
  'avatar-placeholder-filled',
  'close',
  'edit',
  'flag-green',
  'heart',
  'horoscope',
  'logo',
  'mail',
  'play',
  'player',
  'sky',
  'social',
  'gallery',
  'padlock',
  'play-blurred',
  'video-playlist',
  'star',
  // Icon reverse
  'reverse',
];
